import { FC } from 'react';

import { getLocalSvgIcon } from '@telialt/common-icon/src/utils';

import { DualMode, NetflixIconModeDesktop, NetflixIconModeMobile } from './AdaptiveNetflixIcon.styles';

export const AdaptiveNetflixIcon: FC<{ className?: string }> = ({ className }) => {
    const netflixLetterLogoSmall = getLocalSvgIcon('netflix-letter-logo-small');

    return (
        <DualMode className={className}>
            <NetflixIconModeDesktop />
            <NetflixIconModeMobile svg={netflixLetterLogoSmall} />
        </DualMode>
    );
};
